import * as Lodash from 'lodash';
import { useCallback, useEffect } from 'react';
import { When } from 'react-if';
import { Button } from '../../../../common/view/button/button/button';
import { Color } from '../../../../common/view/color/color';
import { Icon } from '../../../../common/view/icon/icon';
import { MonoIcon } from '../../../../common/view/icon/mono/mono-icon';
import { ServerApi } from '../../../../external/server/server.api';
import { CssFuncs } from '../../../../foundation/css/css.funcs';
import { JsFuncs } from '../../../../foundation/js/js.funcs';
import { GapY } from '../../../../foundation/layout/gap-y';
import { StackX } from '../../../../foundation/layout/stack-x';
import { TripleX } from '../../../../foundation/layout/triple-x';
import { TripleY } from '../../../../foundation/layout/triple-y';
import { NodeStore } from '../../../core/node/node.store';
import { AuthStateContext } from '../../../core/user/auth.context';
import { NodeItem } from '../../node/node-item';
import { AppStore } from '../app.store';
import { TodayDone } from './today-done';
import { TodayStyle } from './today.style';

export function Today({ onClickCollapse }: { onClickCollapse?: () => void }) {
  const authState = AuthStateContext.use();
  const appStore = AppStore.use();

  useEffect(() => {
    (async () => {
      if (authState.state.isAuthenticated) {
        const todayNode = await ServerApi.getTodayNode();
        NodeStore.updateItem(todayNode.id, todayNode);
        AppStore.update({ todayNodeId: todayNode.id });

        const nodes = await ServerApi.getNodesAndAllSubNodes([todayNode.id]);
        NodeStore.updateItems(Lodash.keyBy(nodes, 'id'));
      }
    })();
  }, [authState.state.isAuthenticated]);

  const handleDelete = useCallback(async () => {
    if (JsFuncs.isNull(appStore.todayNodeId)) {
      return;
    }

    const sub: [] = [];
    NodeStore.updateItem(appStore.todayNodeId!, { sub });
    ServerApi.updateNode(appStore.todayNodeId!, { sub });
  }, [appStore.todayNodeId]);

  return (
    <TodayStyle.Container>
      <TripleY.Container style={{ height: '100%', width: '100%' }} $gap="20px">
        <TripleY.Side>
          <TripleX.Container $gap="10px" style={{ alignItems: 'center' }}>
            <TripleX.Side>
              <Icon icon={MonoIcon.today} size="24px" color={Color.white4} />
            </TripleX.Side>
            <TripleX.Rest>
              <TodayStyle.HeaderText>Today</TodayStyle.HeaderText>
            </TripleX.Rest>
            <TripleX.Side>
              <StackX $gap="10px" $align="center">
                <Button icon={MonoIcon.trash} size={16} color={Color.white8} />
                <When condition={JsFuncs.isNotNull(onClickCollapse)}>
                  <Button icon={MonoIcon.doubleAnglesLeft} size={24} color={Color.white8} onClick={onClickCollapse!} />
                </When>
              </StackX>
            </TripleX.Side>
          </TripleX.Container>
        </TripleY.Side>
        <TripleY.Rest>
          <div
            style={{ overflow: 'scroll', ...CssFuncs.js.margin({ x: '-20px', y: '-10px' }), ...CssFuncs.js.padding({ x: '20px', y: '10px' }), height: '100%' }}
          >
            <When condition={appStore.todayNodeId}>
              <NodeItem nodeId={appStore.todayNodeId} displaySubItemsOnly disableTodayVisualHolding displayNewSubItemPlaceholder />
            </When>

            <GapY $gap="200px" />
          </div>
        </TripleY.Rest>
        <TripleY.Side>
          <TodayDone />
        </TripleY.Side>
      </TripleY.Container>
    </TodayStyle.Container>
  );
}
